// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/967e2ac8ba477659c20b.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"b7c6ff0d287c6a2401b4","132":"85faca2b2fe68a0832ee","133":"1854ba77ca2aa39168b5"}[chunkId] + ".chunk.js";
};